import { useListRecordsQuery } from '@platform/state/api';
import { useNextCodeQuery } from './api/nextCodeApi';

/**
 * Номер, який отримає новий запис типу (прототип v4 createRecord: code = seq + 1 — чернетка одразу має номер, «Завдання 180»): лічильник
 * типу з API (GET …/next-code); поки сервер його не віддає — найбільший код наявних записів + 1 (після видалення останніх записів може
 * бути меншим за справжній). `undefined` — ще завантажується; `null` — прочитати не вдалося.
 */
export function useNextCode(ws: string, rtKey: string): number | null | undefined {
  const exact = useNextCodeQuery({ ws, rt: rtKey }, { skip: !ws || !rtKey });
  const exactOk = !exact.isError && !(exact.isSuccess && exact.data == null);
  const fallback = useListRecordsQuery({ ws, rt: rtKey, params: { sort: '-code', pageSize: 10, facets: false } }, { skip: !ws || !rtKey || exactOk });
  if (exact.isLoading || exact.isUninitialized) return exact.isUninitialized && (!ws || !rtKey) ? null : undefined;
  if (exact.data != null) return exact.data;
  if (fallback.isLoading || fallback.isUninitialized) return undefined;
  if (fallback.isError || !fallback.data) return null;
  return Math.max(0, ...fallback.data.items.map((r) => r.code || 0)) + 1;
}
